import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNote1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V14H14V21H3Z" fill="currentColor"/><Path d="M16 21H16.4142L21 16.4142V16H16V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote1;
